const selectError = (state) => state.error;

export { selectError };
